import Vue from 'vue';
import payform from './violation-purchase-payform.vue';
import cookie from '../../cookie/cookie';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'onlinePay',
    components: {
        'el-payform': payform,
    },
    data: function () {
        return {
            usernameZh: '',
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        formDataCallback: function (params) {
            this.submitPurchase(params);
        },
        submitPurchase: function (_a) {
            var _this = this;
            var data = _a.data, ref = _a.ref, form = _a.form;
            var amount = data.amount, times = data.times;
            this.$confirm("<p style=\"margin-top:20px;color: #41485d\">\u60A8\u786E\u8BA4\u652F\u4ED8" + toYuan(amount) + "\u5143\u8D2D\u4E70" + times + "\u6B21\u67E5\u8BE2\u8FDD\u7AE0\u6B21\u6570\u5417\uFF1F</p>", '是否确认购买？', {
                confirmButtonText: '确认购买',
                cancelButtonText: '取 消',
                dangerouslyUseHTMLString: true,
            })
                .then(function () {
                var usernameZh = _this.usernameZh;
                var dataForm = Object.assign({
                    type: 'BALANCE',
                    operator: usernameZh,
                }, data);
                _this.$request({
                    url: '/proxy/violation/purchase/do',
                    method: 'post',
                    data: dataForm,
                }).then(function (res) {
                    if (res.errorCode === 0) {
                        _this.$message({
                            type: 'success',
                            message: '购买成功',
                        });
                        ref.resetFields();
                        form.amount = '';
                    }
                    _this.$store.dispatch('balance/GET_BALANCE');
                });
            })
                .catch(function () { });
        },
    },
});
